export default function noop() {}



//////////////////
// WEBPACK FOOTER
// /srv/http/murdocktrust.org/releases/458/web/app/themes/murdock-serenity/node_modules/d3-geo/src/noop.js
// module id = 19
// module chunks = 0